"use client"

import type { ToasterProps } from "sonner"
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

function Toaster({ ...props }: ToasterProps) {
  const { theme = "light" } = useTheme()

  return (
    <Sonner
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      theme={theme as ToasterProps["theme"]}
      {...props}
    />
  )
}

export { Toaster }
